function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M283.5 141.7c0 34.8-28.4 63-63.5 63s-63.5-28.2-63.5-63 28.4-63 63.5-63c35 0 63.5 28.2 63.5 63zm-220-63c-35.1 0-63.5 28.2-63.5 63s28.4 63 63.5 63 63.5-28.2 63.5-63-28.4-63-63.5-63zm0 0"
})));